var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53153 7.98472C8.66591 8.09495 8.82425 8.15 9 8.15C9.17575 8.15 9.33409 8.09495 9.46847 7.98472L16.9329 1.86159C17.0725 1.75541 17.15 1.60393 17.15 1.44297C17.15 1.28273 17.0733 1.12972 16.9376 1.01731C16.6825 0.791456 16.2634 0.797692 15.9982 1.01528L9 6.75599L2.00412 1.01718C1.74981 0.792149 1.33263 0.797696 1.06731 1.01328C0.927574 1.11947 0.85 1.27101 0.85 1.43203C0.85 1.59324 0.927599 1.74712 1.06487 1.85972L8.53153 7.98472Z",
    fill: "#7752fe",
    stroke: "#7752fe",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.9ae6e74e3f024b544b3a232819e1f6dc.svg";
export { ForwardRef as ReactComponent };